<template>
  <div class="kw_medal">
    <div class="medalList">
      <div v-for="(item,index) in lookFieldInfo.childPageJsonArr" :key="'kw_medal_'+index">
        <div class="medalItem">
          <el-badge :value="item.fieldSet[2].defaultValStr" >
            <img class="medalImage" :src="GLOBAL.getFileServeUrl()+item.fieldSet[1].defaultValStr"/>
          </el-badge>
          <div class="medalName">{{item.fieldSet[0].defaultValStr}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'kw_medal',
  props: {
    // 列表调用此组件时 传递的列表数据信息
    initDataInfo: {
      type: Object,
      value: null
    },
    // 列表调用此组件时 列表的页面设置信息
    initpageSetInfo: {
      type: Object,
      value: null
    },
    // 列表调用此组件时 当前字段的信息
    initFieldInfo: {
      type: Object,
      value: null
    },
    // 查看页面 调用时 传递弹出层或加号展开字段的信息
    lookFieldInfo: {
      type: Object,
      value: null
    }
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.medalList{display: flex;justify-content: flex-start}
.medalImage{width:40px;height: 32px}
.medalName{font-size: 12px;color: #A3A3A3}
.medalItem{display: flex;align-items: center;flex-direction: column;margin-left: 10px}
</style>
